export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-50/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10 mb-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-film-line text-lg text-background-50"></i>
              </div>
              <span className="font-heading text-xl text-background-50">香蕉动漫</span>
            </div>
            <p className="text-sm leading-relaxed">
              香蕉动漫免费漫画平台，提供海量免费漫画、动漫免费观看与免费漫画大全。涵盖韩漫、日漫、国漫、条漫等多元类型，无需付费随意畅读。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '人气榜单', href: '#ranking' },
                { label: '平台特色', href: '#features' },
                { label: '读者热评', href: '#comments' },
                { label: '编辑精选', href: '#carousel' },
                { label: '常见问题', href: '#faq' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="text-sm text-background-50/55 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">漫画分类</h4>
            <div className="flex flex-col gap-2">
              {['韩漫推荐', '日漫连载', '国漫精选', '条漫专区', '热血战斗', '恋爱甜宠'].map((label) => (
                <a
                  key={label}
                  href="#index"
                  className="text-sm text-background-50/55 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-50/45 leading-relaxed">
              更多合作伙伴信息即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-background-50/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40 text-center sm:text-left">
            &copy; {new Date().getFullYear()} 香蕉动漫 - 免费漫画阅读平台。本站内容仅供学习交流，版权归原作者所有。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors cursor-pointer">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}